module.exports = __webpack_public_path__ + "img/mig_profile.ef7e7264.jpg";